import {ProductionTaskStatus} from "../model/production-order-execution/ProductionOrderExecution";

export const productionTaskStatusForProductionOrderExecutionToString = new Map<ProductionTaskStatus, string>([
    [ProductionTaskStatus.UNAVAILABLE, "Недоступно"],
    [ProductionTaskStatus.IN_LINE, "В очереди"],
    [ProductionTaskStatus.IN_PRODUCTION, "В производстве"],
    [ProductionTaskStatus.SUSPENDED, "Приостановлено"],
    [ProductionTaskStatus.POSTPONED, "Нет на складе"],
    [ProductionTaskStatus.COMPLETED, "Выполнено"]
])